(function () {
  var configScript = document.currentScript;
  if (!configScript) return;

  var bookingPath = configScript.dataset.bookingPath || '/pages/book-a-table';
  var widgetKey = configScript.dataset.widgetKey;
  var widgetSource = configScript.dataset.widgetSource || 'https://content.simpleerb.com/widget/widget.min.js';
  var widgetPromise;

  var observedWidgets = new WeakSet();
  function linkBookingTelephone(root) {
    root.querySelectorAll('p').forEach(function (paragraph) {
      if (paragraph.querySelector('a[href^="tel:"]')) return;
      var walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var match = /0161\s*637\s*1830/.exec(node.textContent);
        if (!match || node.parentElement.closest('a')) return;
        var before = node.textContent.slice(0, match.index);
        var after = node.textContent.slice(match.index + match[0].length);
        var link = document.createElement('a');
        link.href = 'tel:+441616371830';
        link.textContent = match[0];
        link.style.color = 'inherit';
        link.style.textDecoration = 'underline';
        node.replaceWith(document.createTextNode(before), link, document.createTextNode(after));
      });
    });
  }
  function observeBookingTelephone() {
    document.querySelectorAll('.rt-widget-host').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root || observedWidgets.has(root)) return;
      observedWidgets.add(root);
      linkBookingTelephone(root);
      new MutationObserver(function () { linkBookingTelephone(root); }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  }
  new MutationObserver(observeBookingTelephone).observe(document.body, { childList: true, subtree: true });
  observeBookingTelephone();

  function normalizedPath(path) {
    return path.length > 1 ? path.replace(/\/$/, '') : path;
  }

  function isHeaderLink(link) {
    return Boolean(link.closest(
      'header, #slideout-mobile-navigation, [data-section-type="header"], [data-section-type="mobile-navigation"]'
    ));
  }

  function isBookingLink(link) {
    if (!link || isHeaderLink(link) || link.hasAttribute('download')) return false;

    try {
      var url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin &&
        normalizedPath(url.pathname) === normalizedPath(bookingPath);
    } catch (error) {
      return false;
    }
  }

  function existingWidget() {
    return window.RestaurantBookingWidget &&
      typeof window.RestaurantBookingWidget.open === 'function';
  }

  function loadWidget() {
    if (existingWidget()) return Promise.resolve(window.RestaurantBookingWidget);
    if (widgetPromise) return widgetPromise;

    widgetPromise = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[src="' + widgetSource + '"]');
      var timeout;

      function finish() {
        window.clearTimeout(timeout);
        if (existingWidget()) resolve(window.RestaurantBookingWidget);
        else reject(new Error('SimpleERB loaded without exposing its booking widget.'));
      }

      function fail() {
        window.clearTimeout(timeout);
        reject(new Error('SimpleERB could not be loaded.'));
      }

      if (!script) {
        script = document.createElement('script');
        script.src = widgetSource;
        script.async = true;
        script.dataset.widgetKey = widgetKey;
        document.head.appendChild(script);
      }

      script.addEventListener('load', finish, { once: true });
      script.addEventListener('error', fail, { once: true });
      timeout = window.setTimeout(fail, 15000);

      if (existingWidget()) finish();
    }).catch(function (error) {
      widgetPromise = null;
      throw error;
    });

    return widgetPromise;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      !isBookingLink(link)
    ) return;

    if (link.target && link.target.toLowerCase() !== '_self') return;

    event.preventDefault();
    link.setAttribute('aria-busy', 'true');

    loadWidget()
      .then(function (widget) {
        return widget.open();
      })
      .catch(function (error) {
        console.error(error);
        window.location.assign(link.href);
      })
      .finally(function () {
        link.removeAttribute('aria-busy');
      });
  }, true);
})();
